/**
 * Generated runtime TestId mirror for frontend/src/pages/ScriptEditorPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ScriptEditorPageTestIds = {
  badgeUnsaved: "badge-unsaved",
  btnBack: "btn-back",
  btnBackError: "btn-back-error",
  btnBackTaskNotFound: "btn-back-task-not-found",
  btnCancelDiscard: "btn-cancel-discard",
  btnConfirmDiscard: "btn-confirm-discard",
  btnConflictCancel: "btn-conflict-cancel",
  btnConflictReload: "btn-conflict-reload",
  btnSave: "btn-save",
  editorError: "editor-error",
  editorLoading: "editor-loading",
  editorTaskNotFound: "editor-task-not-found",
  editorToolbar: "editor-toolbar",
  scriptEditorPage: "script-editor-page"
} as const;
